import React, { FC } from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { withUserType } from '../withUserType';

/** Sends `/overview` on to `/overview/all`, the way Troubleshooting does. */
const AOPOverviewPage: FC<any> = ({ childRoutes, userType }): React.ReactElement => {
	const basePath = `/${userType}/workflows/agent_operating_procedures/overview`;

	return (
		<div>
			<div>
				<Route
					path={basePath}
					exact={true}
					render={() => <Redirect to={{ pathname: `${basePath}/all` }} />}
				/>
				{childRoutes.map((route, index) => (
					<RouteWithSubRoutes key={index} {...route} />
				))}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,
});

export default withUserType(withRouter<any, any>(connect(mapStateToProps)(AOPOverviewPage)));
